




























































































































































































import { useSockets } from '@/app/composable/socket';
import store from '@/app/store';
import Auth from '@/modules/auth/api/auth';
import Keycloak from '@/modules/auth/api/keycloak';
import { NotificationListItem } from '@/modules/notification/components';
import { useNotifications } from '@/modules/notification/composable';
import { BellIcon, InformationCircleIcon, MenuAlt2Icon, UserCircleIcon } from '@vue-hero-icons/outline';
import { ChevronDownIcon } from '@vue-hero-icons/solid';
import { Ref, computed, defineComponent, onBeforeUnmount, ref } from '@vue/composition-api';
import { ConfirmModal, OnClickOutside, Scrollbar } from '../components';
import { useFeatureFlags } from '../composable';
import { WebSocketsRoomTypes } from '../constants';

export default defineComponent({
    name: 'PageHeader',
    components: {
        UserCircleIcon,
        ChevronDownIcon,
        OnClickOutside,
        BellIcon,
        MenuAlt2Icon,
        Scrollbar,
        NotificationListItem,
        ConfirmModal,
        InformationCircleIcon,
    },
    setup(props, { root }) {
        const userMenuOpen: Ref<boolean> = ref<boolean>(false);
        const openModelBrowser = ref<boolean>(false);
        const user = computed(() => store.state.auth.user);
        const { subscribe, unsubscribe, connected, socketDisconnect, WebSocketsEvents, leaveSocketRoom } = useSockets();
        const { isEnabled: isFeatureEnabled } = useFeatureFlags();

        const userNavigation = computed(() => [
            { name: 'Personal Profile', route: 'user:edit', visible: true },
            {
                name: 'Organisation Details',
                route: 'organization:edit',
                visible: true,
            },
        ]);

        const {
            openNotifications,
            closeNotifications,
            notifications,
            numNotifications,
            viewAllNotifications,
            enableMarkAllAsSeen,
            markAllAsSeen,
            showMarkAllAsSeenModal,
        } = useNotifications(root);

        const logout = async () => {
            (root as any).$toastr.removeByType('info');
            await Auth.logout();
            socketDisconnect();
            store.commit.notificationEngine.CLEAR_NOTIFICATIONS();
            store.commit.auth.CLEAR_KEYCLOAK_TOKEN();
            store.commit.auth.CLEAR_USER();
            store.commit.sharing.CLEAR_NETWORK();
            await Keycloak.logout(process.env.VUE_APP_URL);
        };

        const onMessage = async () => {
            await logout();
        };

        subscribe(WebSocketsEvents.User, onMessage);
        onBeforeUnmount(() => {
            unsubscribe(WebSocketsEvents.User);
            leaveSocketRoom(WebSocketsRoomTypes.User);
        });

        const close = () => {
            userMenuOpen.value = false;
        };

        return {
            user,
            userMenuOpen,
            notifications,
            userNavigation,
            numNotifications,
            openModelBrowser,
            openNotifications,
            enableMarkAllAsSeen,
            showMarkAllAsSeenModal,
            close,
            logout,
            markAllAsSeen,
            closeNotifications,
            viewAllNotifications,
            connected,
            isFeatureEnabled,
        };
    },
});
